import { render } from "./OpinionTable.vue?vue&type=template&id=0223f568&scoped=true"
import script from "./OpinionTable.vue?vue&type=script&lang=js"
export * from "./OpinionTable.vue?vue&type=script&lang=js"

import "./OpinionTable.vue?vue&type=style&index=0&id=0223f568&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0223f568"

export default script